import { stringToPath } from './objects';
import { isEmpty } from '@ember/utils';

/*
This regex is to match variables used in liquid expressions.
It matches variables in {{ }} or {% %} tags.
It matches with or without whitespace after the liquid tags (e.g. {{event.asdf}} and {{ event.asdf }} will both be detected).
It matches both dot-notation and bracket-notation for accessing nested elements, e.g. {{event.city}} and {{event["city"]}}.
It matches mixed dot-notation and bracket-notation: {{event["my_attribute"].field}}.
It matches array indices: {{event.attendees[0].name}}.
It matches variables used in {% %} tags, e.g. {% if event.city == "Melbourne" %}.
Breakdown of the regular expression:

{                                 - match { character
[{%]                              - match another { or a %
[^{%]*                            - match anything but { or % zero or more times - to catch whitespace
(                                 - start capture group - this will capture the actual variable path
root                              - match the root variable explicitly
(?:                               - start a non-capturing group
(?:\\[["']?[A-Za-z0-9_]+["']?\\]) - matches any text in [] brackets, with either " or ' as quotes (bracket-notation for nested elements)
|                                 - or expression to match either the above or below
(?:\\.[A-Za-z0-9_]+)              - matches a dot followed by any text (dot-notation for accessing nested elements)
)*                                - end the non-capturing group and match it zero or more times
)                                 - end capture group (for variable path)
[^%}]*                            - match anything but % or } zero or more times - to catch whitespace
[%}]                              - match either % or }
}                                 - match } character

*/
function generateRegex(root: string) {
  return new RegExp(`{[{%][^{%]*(${root}(?:(?:\\[["']?[A-Za-z0-9_]+["']?\\])|(?:\\.[A-Za-z0-9_]+))*)[^%}]*[%}]}`, 'g');
}

export function findUsedVariablePaths(variableRoot: string, liquidString: string) {
  let regex = generateRegex(variableRoot);

  let match = regex.exec(liquidString);
  let matches = [];

  while (match) {
    matches.push(match[1]);
    match = regex.exec(liquidString);
  }

  return matches.map((m) => stringToPath(m));
}

export function getLiquidToInsert(
  variable: string,
  fallback: string | null | undefined,
  templateEngine: number | null | undefined,
): string {
  if (isEmpty(fallback)) {
    return `{{${variable}}}`;
  }

  let isLiquidJsRenderer = templateEngine === 1;

  return isLiquidJsRenderer
    ? `{{ ${variable} | default: "${fallback}" }}`
    : `{% if ${variable} != blank %}{{${variable}}}{% else %}${fallback}{% endif %}`;
}
